import * as React from 'react';
import StoryblokClient from 'storyblok-js-client';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { useLocation } from '@reach/router';
import { extractLanguage } from '../../helpers/common';

const Storyblok = new StoryblokClient({
  accessToken: 't9DFrGNLE0hGttjZo4UfhQtt', // Replace with your public token or use env variable
});

export default function ReferencesTiles({ blok }) {
  const location = useLocation();
  const currentLanguage = extractLanguage(location.pathname);
  const { component } = blok;

  // Memoize tileIds to avoid unnecessary re-renders
  const tileIds = React.useMemo(() => (Array.isArray(blok.tile) ? blok.tile : []), [blok.tile]);
  const [tiles, setTiles] = React.useState([]);

  React.useEffect(() => {
    if (!tileIds.length) return;
    let isMounted = true;
    Storyblok.get('cdn/stories', {
      by_uuids: tileIds.join(','),
      version: 'published',
      per_page: tileIds.length,
    }).then(res => {
      if (isMounted) setTiles(res.data.stories);
    });
    return () => { isMounted = false; };
  }, [tileIds.join(',')]); // Only re-fetch if IDs actually change

  const styles = clsx(
    `${component} px-4 lg:px-16 grid gap-4 grid-cols-1 s:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 pb-8 lg:pb-32`,
  );

  const parentRoute = currentLanguage === 'en' ? '/en/references' : '/references';
  console.log('dvfbfbddfbfbdb: ', tiles);
  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {tiles.map((item) => (
        <div
          className="aspect-[16/9] relative h-full overflow-hidden"
          key={item.uuid}
        >
          {item?.content?.image?.filename && (
            <img
              src={item.content.image.filename}
              className="w-auto object-cover h-full"
              alt={item.content.image.alt}
            />
          )}
          <Link
            to={currentLanguage === 'en' ? `/en/${item.translated_slugs[0].path}` : `/${item.full_slug}`}
            className="absolute top-0 w-full h-full flex"
          >
            <div className="absolute w-full h-full bg-green-800 z-10 opacity-75 hover:bg-slate-700 hover:opacity-20 transition" />
            <div className="m-auto z-20 pointer-events-none">
              {item?.content?.logo?.filename ? (
                <img
                  src={item.content.logo.filename}
                  width="300"
                  height="200"
                  className="max-h-8 s:max-h-12 xl:max-h-16 h-full max-w-[100px] s:max-w-[150px] xl:max-w-[175px] w-full object-contain"
                  alt={item.content.logo.alt}
                  loading="lazy"
                />
              ) : (
                <h4>{item.name || 'reference title'}</h4>
              )}
            </div>
          </Link>
        </div>
      ))}
      {blok?.showmore_tile && (
        <Link
          to={parentRoute}
          className="flex bg-green-800 hover:bg-green-900 text-white group aspect-[16/9]"
        >
          <div className="flex m-auto items-center group-hover:scale-105 transition-transform">
            <span className="mr-2">
              {currentLanguage === 'default' ? 'Mehr' : 'More'}
            </span>
            <FontAwesomeIcon
              icon={icon({ prefix: 'far', iconName: 'arrow-right' })}
              size="2x"
            />
          </div>
        </Link>
      )}
    </div>
  );
}
